import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { BREAKPOINT_EXTRA_SMALL, EXPLORE_SORT_CREATE_PARAMS, GROUP_SORT_TOPS, PRO_TIMELINE_SORTS, VIDEO_SORTS  } from '../constants'
import { fetchAccountByUsername } from '../actions/accounts'
import { fetchStatus } from '../actions/statuses'
import { parseQuerystring } from '../utils/querystring'
import { timelineDequeue, timelineFetchPaged, timelineQueue } from '../store/timelines'
import FooterBar from '../components/footer_bar'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import { SidebarXS } from '../features/ui/util/async_components'

class MediaPage extends React.PureComponent {

  componentDidMount() {
    const { account, timeline, timelineId, status, statusId, onFetchAccountByUsername, onFetchStatus, username } = this.props
    if (!account) onFetchAccountByUsername(username)
    if (!status && statusId) onFetchStatus(statusId)

    if (!!timelineId && !timeline) {
      this.props.onFetchTimeline(timelineId)

      if (!!statusId) {
        // auto insert into first slot
        this.props.onTimelineQueue(timelineId, statusId)
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      account,
      timeline,
      timelineId,
      indexInTimeline,
      status,
      statusId,
      onFetchAccountByUsername,
      onFetchStatus,
      username,
    } = this.props
    if (!account && prevProps.username !== username) {
      onFetchAccountByUsername(username)
    }

    if (!status && prevProps.statusId !== statusId) {
      onFetchStatus(statusId)
    }

    if (!!timelineId && !!timeline && indexInTimeline) {
      const statusIds = timeline.get('items')
      // if indexInTimeline is next to last, fetch more
      if (statusIds.size - 2 < indexInTimeline && !timeline.get('isLoading') && timeline.get('hasNext')) {
        this.props.onFetchTimeline(timelineId)
      }
    }
  }

  render() {
    const { children, isXS, timeline, indexInTimeline } = this.props

    if (isXS && !!timeline) {
      return (
        <div className={[_s.d, _s.h100PC, _s.minH100VH, _s.bgBlackBlack, _s.w100PC, _s.overflowHidden].join(' ')}>
          <WrappedBundle component={SidebarXS} />  
          <div className={[_s.d, _s.flexRow, _s.w100PC, _s.flexGrow1].join(' ')}>
            <main role='main' className={[_s.d, _s.posFixed, _s.top0, _s.right0, _s.left0, _s.bottomCalc100Env].join(' ')}>
              <div className={[_s.d, _s.w100PC, _s.h100PC, _s.jcEnd].join(' ')}>
                {children}
              </div>
            </main>
          </div>
          <FooterBar title="Media" />
        </div>
      )
    }

    return (
      <div className={[_s.d, _s.h100PC, _s.minH100VH, _s.bgBlackBlack, _s.w100PC, _s.overflowHidden].join(' ')}>
        {children}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const statusId = props.id || props.params.statusId
  const username = props.username || props.params.username
  let status = state.getIn(['statuses', statusId])
  let account = status ? state.getIn(['accounts', status.get('account')]) : undefined

  const {
    timeline: timelineId,
    only_following: onlyFollowing,
  } = parseQuerystring(props.location.search)
  const timeline = !!timelineId ? state.getIn(['timelines', timelineId]) : null
  const statusIds = !!timeline ? timeline.get('items') : null
  const isLoading = !!timeline ? timeline.get('isLoading') : null
  const hasNext = !!timeline ? timeline.get('hasNext') : null
  const indexInTimeline = !!statusIds ? statusIds.indexOf(statusId) : -1

  return {
    statusId,
    status,
    account,
    username,
    timelineId,
    timeline,
    indexInTimeline,
    isLoading,
    hasNext,
    onlyFollowing,
    sortByValue: !!timeline ? timeline.get('sortByValue') : undefined,
    isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
  }
}

const mapDispatchToProps = (dispatch, { sortByValue }) => ({
  onFetchAccountByUsername: (username) => dispatch(fetchAccountByUsername(username)),
  onFetchStatus: (id) => dispatch(fetchStatus(id)),
  onTimelineQueue: (timelineId, id) => {
    // auto insert into first slot
    dispatch(timelineQueue(timelineId, [id]))
    dispatch(timelineDequeue(timelineId))
  },
  onFetchTimeline: (timelineId, onlyFollowing) => {
    const expandOpts = {
      onlyFollowing,
      dequeueResults: 1,
      sorts: VIDEO_SORTS,
      topSorts: GROUP_SORT_TOPS,
      usePages: ['top', 'hot'].indexOf(sortByValue) > -1,
      createParams: EXPLORE_SORT_CREATE_PARAMS,
    }
    if (timelineId === 'video-clips') {
      expandOpts.endpoint = '/api/v2/timelines/video?media_type=clips'
      dispatch(timelineFetchPaged(timelineId, expandOpts))
    }
    else if (timelineId === 'video') {
      expandOpts.endpoint = '/api/v2/timelines/video'
      dispatch(timelineFetchPaged(timelineId, expandOpts))
    }
  }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MediaPage))
